import { CoalitionCarousel } from "./../CoalitionCarousel";
import { CoalitionBanner } from "../CoalitionBanner";

export const BannersBlock = ({ banners = [] }) => {
  return (
    <>
      {banners && banners.length > 0 ? (
        <CoalitionCarousel>
          {banners.map((item, index) => (
            <CoalitionBanner key={index} item={item} />
          ))}
        </CoalitionCarousel>
      ) : null}
    </>
  );
};
